import axios from "axios";
import { baseURL } from "../utils/URL";

const onAddContract = async ( postData:any ,config: any) => {
    try {
      const response = await axios.post(`${baseURL}/contract`, postData,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };
const onAddContractDoc = async ( postData:any ,config: any) => {
    try {
      const response = await axios.post(`${baseURL}/contractdoc`, postData,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };
const onUpdateContract = async ( postData:any ,config: any) => {
    try {
      const response = await axios.patch(`${baseURL}/contract`, postData,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };


  const onGetOrgContracts = async (id:any ,config: any) => {
    try {
      const response = await axios.get(`${baseURL}/contract/organization/${id}`,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };
  const onGetContractDocById = async (id:any ,config: any) => {
    try {
      const response = await axios.get(`${baseURL}/contractdoc/contract/${id}`,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };
  const onGetContractsById = async (id:any ,config: any) => {
    try {
      const response = await axios.get(`${baseURL}/contract/${id}`,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };

  export {onAddContract,onGetContractDocById,  onUpdateContract, onGetContractsById,onAddContractDoc, onGetOrgContracts}